import { useStore, useStoreUI } from '@assets/model/Store';
import { useConfig } from '@assets/model/StoreConfig';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { Flex } from '../UI/Flex/Flex';
import { Panel } from '../Panel/Panel';
import { convertMarkdown } from '@assets/utils/Utils';
import * as style from './MDViewerPanel.module.less';

interface IMDViewer {
    mdFileUrl: string;
    title_display: string;
    joined?: boolean;
}

export const MDViewerPanel = observer((props: IMDViewer) => {
    const uiStore = useStoreUI();
    const [mdFileContent, setMdFileContent] = useState<string>('');

    useEffect(() => {
        const fetchFile = async () => {
            try {
                const response = await fetch(props.mdFileUrl);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Use .json(), .text(), or .blob() depending on the file type
                const result = await response.text();
                const convertedContent = convertMarkdown(result);
                setMdFileContent(convertedContent);
            } catch (error) {
                console.error('Could not fetch the file:', error);
            }
        };

        fetchFile();
    }, [props.mdFileUrl]);

    return (
        <Flex fillCell={true}>
            <Panel
                shadow={!props.joined}
                fillCell={true}
                className={props.joined ? style.joined : ''}
            >
                <div
                    className={style.markdownContent}
                    dangerouslySetInnerHTML={{
                        __html: mdFileContent
                    }}
                />
            </Panel>
        </Flex>
    );
});
